import Loadable, { NullLoader } from '@comeon/loadable';

// Make all the containers loadable under single chunk.

const SearchDesktopPopoverContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-search-desktop-popover-container" */
			'./sportsbook-search-desktop-popover-container'
		),
	loading: NullLoader
});

const SearchMobilePopoverContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-search-mobile-popover-container" */
			'./sportsbook-search-mobile-popover-container'
		),
	loading: NullLoader
});

const SearchPageContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-search-page-container" */
			'./sportsbook-search-page-container'
		),
	loading: NullLoader
});

export { SearchDesktopPopoverContainer, SearchMobilePopoverContainer, SearchPageContainer };
